import { FeatureFlagStore, useAppStore, UserStore } from '@/stores';
import { getAuth, signInWithEmailAndPassword, updatePassword } from 'firebase/auth';
import { auth } from './firebaseService';

export class AuthService {
	static async login(email: string, password: string) {
		const userStore = UserStore();
		const response = await signInWithEmailAndPassword(auth, email, password);
		userStore.setUser(response.user);
	}

	static async changePassword(password: string) {
		const _auth = await getAuth();
		await updatePassword(_auth.currentUser!, password);
	}

	static async logout() {
		await auth.signOut();
	}

	static async waitForAuthInit() {
		let unsubscribe = null as any;
		await new Promise<void>((resolve) => {
			unsubscribe = auth.onAuthStateChanged((_) => resolve());
		});
		(await unsubscribe!)();
	}

	async authorizeFlow() {
		const userStore = UserStore();
		const appStore = useAppStore();
		const featureFlagStore = FeatureFlagStore();

		// Sem await, e antes do onAuthStateChanged só porque é barato: init() apenas cria o cliente
		// e dispara a avaliação em segundo plano. NÃO transforme isto num await — a montagem
		// anterior (Flagsmith) aguardava aqui, e como o App.tsx só sai do spinner dentro do callback
		// abaixo, todo boot pagava até 2,5s de loading antes da tela de login. Ver o histórico do
		// antigo ffStore.ts: "hotfix: ffStore travando app".
		featureFlagStore.init();

		auth.onAuthStateChanged(async (response) => {
			if (response) {
				userStore.setUser(response);
				const result = await auth?.currentUser?.getIdTokenResult(true);
				if (result) {
					await userStore.setClaims(result.claims);
					// Em paralelo com as configurações, para não somar uma ida à API no boot. Precisa
					// terminar antes do setAppStatus: as telas de criação leem o status ao montar.
					await Promise.all([appStore.setAppSettings(), userStore.loadPartnerBrokerStatus()]);

					// Também sem await: a segmentação por imobiliária/papel corrige o snapshot
					// quando chegar, e o login não tem por que esperar por ela.
					featureFlagStore.identify({
						identifier: result.claims['Id'] as string,
						role: result.claims['Role'] as string,
						brokerId: result.claims['BrokerId'] as string,
					});
				}
			}
			if (!response) {
				userStore.showLogin();
				featureFlagStore.reset();
			}

			appStore.setAppStatus(true);
		});
	}
}
